//Función para manejar el click en los details:

export const handleClickDetail = (e, { setSelectedCategory }) => {
	//Cuando hago clic por defecto o selecciona el elemento summary y el span.
	//Si detecta primero el summary, selecciono el parentNode (details), sino selecciono el parentNode del parentNode (details):
	let selectedDetail;

	if (e.target.tagName === 'SUMMARY') {
		selectedDetail = e.target.parentNode; //El onclik detecta primero el summary y luego el details, por eso tengo que ir al parentNode.
	} else if (e.target.tagName === 'SPAN') {
		selectedDetail = e.target.parentNode.parentNode;
	} else {
		return;
	}

	//Una vez que ya sé el details seleccionado, cierro todos los details menos el seleccionado:
	const details = document.querySelectorAll(
		'.studio-text-container details'
	);
	details.forEach((detail) => {
		if (detail !== selectedDetail) {
			detail.open = false;
		}
	});

	//Si al pulsar el details está abierto, capturo su categoría y la guardo en el estado, sino reseteo el estado:
	if (!selectedDetail.open) {
		setSelectedCategory(selectedDetail.getAttribute('category'));
	} else {
		setSelectedCategory('');
	}

	/*< Función para mover la barra de los summary >*/

	const resetOtherBars = (exceptSpan) => {
		const bars = document.querySelectorAll(
			'.studio-text-container summary > span'
		);
		bars.forEach((span) => {
			if (span !== exceptSpan) {
				span.innerText = '/';
			}
		});
	};

	// Cuando el onClick detecte el elemento Summary
	if (e.target.tagName === 'SUMMARY') {
		const bar = e.target.children[0];
		if (e.target.parentNode.open) {
			bar.innerText = '/';
		} else {
			bar.innerText = '__';
			resetOtherBars(bar);
		}
	}

	// Cuando el onClick detecte el elemento Span
	if (e.target.tagName === 'SPAN') {
		if (e.target.parentNode.parentNode.open) {
			e.target.innerText = '/';
		} else {
			e.target.innerText = '__';
			resetOtherBars(e.target);
		}
	}
};

/*----------------------- Pantalla completa de las imágenes -----------------------

	//Función para poner a pantalla completa una imagen:
	const handleClickImage = (e) => {
		const image = e.target;
		if (image.requestFullscreen) {
			image.requestFullscreen();
		} else if (image.webkitRequestFullscreen) {
			image.webkitRequestFullscreen();
		} else if (image.msRequestFullscreen) {
			image.msRequestFullscreen();
		}
	};

	//Detectar el cambio de imagen y aplicar la función:
	useEffect(() => {
		const images = document.querySelectorAll('img');
		images.forEach((image) => {
			image.addEventListener('click', handleClickImage);
		});
	}, [images]);
	*/
